import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 400px;
`;

const StyledHeadingContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

export { StyledContainer, StyledHeadingContainer, StyledCloseButtonContainer };
